import "./App.css";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Login from "./pages/auth/Login";
import Dashboard from "./pages/Dashboard";
// eslint-disable-next-line no-unused-vars
import PettyCashList from "./pages/petty_cash/PettyCashList";
// eslint-disable-next-line no-unused-vars
import PettyCashDetail from "./pages/petty_cash/PettyCashDetail";
import PettyCashFundRequests from "./pages/petty_cash/PettyCashFundRequests";
import PettyCashFundRequestDetail from "./pages/petty_cash/PettyCashFundRequestDetail";
import PettyCashEntities from "./pages/petty_cash/PettyCashEntities";
import PettyCashCurrencies from "./pages/petty_cash/PettyCashCurrencies";
import PettyCashSettings from "./pages/petty_cash/PettyCashSettings";

import ProtectedRoutes from "./Routes/ProtectedRoutes";
import PageNotFound from "./pages/errors/PageNotFound";
import Layout from "./components/layout/Layout";
import { GOOGLE_CLIENT_ID } from "./config";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Invite from "./pages/auth/Invite";
import { WorkspaceProvider } from "./providers/WorkspaceProvider";
import BrandMetadataSync from "./components/BrandMetadataSync";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <BrandMetadataSync />
        <Toaster position="top-right" />
        <WorkspaceProvider>
          <Routes>
            <Route path="/login" exact element={<Login />} />
            <Route path="/invite" exact element={<Invite />} />
            <Route
              path="/forgot-password"
              exact
              element={<ForgotPassword />}
            />
            <Route element={<ProtectedRoutes />}>
              <Route element={<Layout />}>
                <Route path="/" exact element={<PettyCashList />} />
                <Route
                  path="/petty-cash/fund-requests"
                  exact
                  element={<PettyCashFundRequests />}
                />
                <Route
                  path="/petty-cash/fund-requests/:id"
                  exact
                  element={<PettyCashFundRequestDetail />}
                />
                <Route
                  path="/petty-cash/entities"
                  exact
                  element={<PettyCashEntities />}
                />
                <Route
                  path="/petty-cash/currencies"
                  exact
                  element={<PettyCashCurrencies />}
                />
                <Route
                  path="/petty-cash/settings"
                  exact
                  element={<PettyCashSettings />}
                />
                <Route
                  path="/petty-cash/:id"
                  exact
                  element={<PettyCashDetail />}
                />
              </Route>
              <Route path="*" exact element={<PageNotFound />} />
            </Route>
          </Routes>
        </WorkspaceProvider>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
